import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Paper from 'material-ui/Paper'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import Header from '../../components/Header/Header'
import Constants from '../../utils/CommonConstants'
import { getInvoiceMonth, resetInvoiceMonth } from '../../actions/invoiceMonth'
import { SHOW_SNACKBAR_TOASTR } from '../../actions/loading'
import RaisedButton from 'material-ui/RaisedButton/RaisedButton'

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  invoiceMonth: state.invoiceMonth
})

const mapDispatchToProps = dispatch => ({
  getInvoiceMonth: bindActionCreators(getInvoiceMonth, dispatch),
  resetInvoiceMonth: bindActionCreators(resetInvoiceMonth, dispatch),
  dispatch
})

const paperMonth = {
  display: 'inline-block',
  padding: '5px 10px'
}

class InvoiceMonth extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isUpdating: false,
      showConfirm: false
    }
    this.showConfirm = this.showConfirm.bind(this)
    this.resetInvoiceMonth = this.resetInvoiceMonth.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  componentWillMount() {
    const { getInvoiceMonth } = this.props
    getInvoiceMonth()
  }

  componentWillReceiveProps(nextProps) {
    const { invoiceMonth, dispatch } = this.props
    const { isUpdating } = this.state
    if ((nextProps.invoiceMonth !== invoiceMonth) & isUpdating) {
      dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Invoice month updated successfuly.'
      })
      this.setState({
        isUpdating: false,
        showConfirm: false
      })
    }
  }

  resetInvoiceMonth() {
    const { resetInvoiceMonth } = this.props
    this.setState(
      {
        isUpdating: true
      },
      resetInvoiceMonth
    )
  }

  handleClose() {
    this.setState({
      showConfirm: false
    })
  }

  showConfirm() {
    this.setState({
      showConfirm: true
    })
  }

  render() {
    const { invoiceMonth } = this.props
    const { isUpdating, showConfirm } = this.state
    const actions = [
      <FlatButton label='Reset' primary onClick={this.resetInvoiceMonth} />,
      <FlatButton label='Cancel' primary onClick={this.handleClose} />
    ]
    return (
      <div>
        <Header {...this.props} title='Unified RCM Dashboard' />
        {invoiceMonth && (
          <div className='invoice-month'>
            <br />
            <div className='ta-c'>
              {' '}
              Current Invoice Month:{' '}
              <Paper style={paperMonth} zDepth={1}>
                {Constants.months[invoiceMonth.value]}
              </Paper>
            </div>
            <br />
            <div className='ta-c'>
              <RaisedButton
                disabled={isUpdating}
                primary
                label='Set to Current Month'
                onClick={this.showConfirm}
              />
            </div>
          </div>
        )}
        <Dialog
          actions={actions}
          modal={false}
          open={showConfirm}
          onRequestClose={this.handleClose}
        >
          Are you sure, you want to set Invoice month to current month?
        </Dialog>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceMonth)



/** WEBPACK FOOTER **
 ** ./src/containers/InvoiceMonth/InvoiceMonth.js
 **/